<template>
    <div class="bo-text-block">
        <div
            :class="[
                'text-content',
                text.alignment,
            ]"
            v-for="text in textblocks"
            :key="text.index"
        >
            <div class="title">{{ text.title }}</div>
            <div class="subtitle">{{ text.text }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        textblocks: {
            type: Array,
            default: "",
        },
    },
};
</script>
